import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import i18n from './locales'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)
const pinia = createPinia()

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(ElementPlus)

app.mount('#app')

// ==================== 全局屏蔽打印信息（开发版） ====================
// 启用时注释下面这行即可恢复打印
// console.log = console.warn = console.error = () => { };

/**
 * 全局控制台打印控制
 * 开发环境：全部打印（调试用）
 * 测试环境：关闭log，保留warn/error
 * 生产环境(线上)：只保留error，其余全部关闭
 */
const env = process.env.NODE_ENV

if (env === 'development') {
  // 开发环境：不做任何处理，全部正常打印
  console.log = () => { }
  console.info = () => { }
  console.debug = () => { }
} else if (env === 'staging') {
  // 测试/预发布环境：关闭普通日志，保留警告和错误
  console.log = () => { }
  console.info = () => { }
  console.debug = () => { }
} else if (env === 'production') {
  // 生产线上环境：只保留 error，其余全部屏蔽
  console.log = () => { }
  console.info = () => { }
  console.debug = () => { }
  console.warn = () => { }
  // console.error = () => {} // 如需线上完全无任何打印，取消注释
}


// ==================================================================

